import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(private injector: Injector) { }

  handleError(err) {
    const snackbar = this.injector.get(MatSnackBar);

    // Skip snackbar for 401/504 — handled by interceptor with session expired dialog
    if (err && err.rejection && (err.rejection.status === 401 || err.rejection.status === 504)) {
      console.log(err);
      return;
    }
    if (err && err.status && (err.status === 401 || err.status === 504)) {
      console.log(err);
      return;
    }

    let message: string;
    if (typeof err === typeof 's') {
      message = err
    } else {
      message = err.message || 'Some Error Occured. Please Try Again Later'
    }
    console.log(err)
    snackbar.open(message, 'OK', { duration: 3000 });

    // throw err;
  }

}
